<template>
	<div class="weighing-factors-navigation tw-pt-4">
		<card-navigation
			@onPrevClick="$emit('onPrevClick')"
			@onNextClick="$emit('onNextClick')"
			:disable-next-button="!hasNext"
			:disable-prev-button="!hasPrev"
			:bordered="false"
			class="tw--mx-5"
		>
			<div class="weighing-factors-navigation-content ">
				<div class="tw-py-8 tw-px-16 tw-flex tw-justify-between tw-items-center">
					<div class="weighing-factors-navigation-factor tw-flex uppercase tw-items-center">
						<img :src="pivotFactorUrlImage" alt=''>
						<h3 class="tw-m-0 text-info">{{ pivotFactorName }}</h3>
					</div>
					<div class="tw-py-3 tw-px-10 weighing-factor-compare-value text-info text-xl font-weight-bold">
						{{ weighingValue }}
					</div>
				</div>
			</div>
		</card-navigation>
	</div>
</template>

<script>
import CardNavigation from '@/modules/shared/components/ui/CardNavigation';

export default {
	name: 'WeighingFactorsNavigation',
	components: { CardNavigation },
	props: ['weighingValue', 'pivotFactorUrlImage', 'pivotFactorName', 'hasNext', 'hasPrev'],
};
</script>

<style lang="scss" scoped>
.weighing-factors-navigation {
	position: relative;
	.weighing-factor-compare-value {
		border: 1px solid var(--app-color-gray);
		border-radius: 5px;
	}
	.weighing-factors-navigation-factor {
		img {
			width: 30px;
			height: 30px;
			margin-right: 10px;
		}
	}
	.weighing-factors-navigation-content {
		min-height: 100px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorsNavigation.vue